// TEMPORARY dev harness — static replica of the merged header (real Uno classes)
// to review alignment/polish in isolation. Delete this file + its route.
import { classNames } from '~/utils/classNames';

function Tab({ name, active }: { name: string; active?: boolean }) {
  return (
    <div
      className="flex items-center"
      style={{
        gap: 6,
        padding: '6px 12px',
        borderRadius: active ? '8px 8px 0 0' : 0,
        background: active ? 'var(--color-sunken)' : 'transparent',
        border: active ? '1px solid var(--color-hairline)' : '1px solid transparent',
        borderBottom: 0,
        fontSize: 12,
        color: active ? 'var(--color-primary)' : 'var(--color-muted)',
        maxWidth: 220,
      }}
    >
      <span className={classNames('ui-dot', active ? 'ui-dot-live' : 'ui-dot-draft')} />
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{name}</span>
      <span className="i-ph:x text-xs" style={{ opacity: 0.4 }} />
    </div>
  );
}

export default function DevHeader() {
  return (
    <div className="ui-root min-h-screen bg-page">
      <header
        className="flex items-center"
        style={{
          gap: 8,
          padding: '8px 14px',
          borderBottom: '1px solid var(--color-hairline)',
          background: 'var(--color-surface)',
        }}
      >
        <div className="flex items-end" style={{ flex: 1, minWidth: 0, gap: 0 }}>
          <Tab name="Create a dark theme landing" />
          <Tab name="build me a website for nature" />
          <Tab name="build me a simple landing page" active />
        </div>

        <div className="flex flex-shrink-0 items-center gap-2 pl-2">
          <span className="mr-0.5 hidden items-center gap-1.5 text-[12px] text-secondary md:inline-flex">
            <span className="ui-dot ui-dot-live" />
            Ready
          </span>
          <div className="ui-segmented">
            <button
              type="button"
              className="inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[12px] font-medium text-secondary transition-colors hover:bg-sunken hover:text-primary"
            >
              <span className="i-ph:eye text-[13px]" />
              Preview
            </button>
            <button
              type="button"
              className="inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[12px] font-medium text-secondary transition-colors hover:bg-sunken hover:text-primary"
            >
              <span className="i-ph:code text-[13px]" />
              Code
            </button>
          </div>
          <button
            type="button"
            className="inline-flex items-center gap-1.5 rounded-full bg-accent px-3.5 py-1.5 text-[12px] font-semibold text-[#0A0A0A] shadow-[0_4px_16px_-5px_var(--accent-glow)]"
          >
            <span className="i-ph:rocket-launch text-[13px]" />
            Publish
          </button>
          <button type="button" className="ui-btn-icon">
            <span className="i-ph:share-network text-[16px]" />
          </button>
        </div>
      </header>

      <div className="p-8 text-[12px] text-faint">chat thread…</div>
    </div>
  );
}
